// Schrijft nieuwsbrief-inschrijvingen weg naar Klaviyo in plaats van naar het
// Shopify-klantformulier. Bindt aan elk formulier met data-klaviyo-signup.
(function () {
  'use strict';

  var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions';
  var REVISION = '2026-07-15';

  function toon(el) { if (el) el.hidden = false; }
  function verberg(el) { if (el) el.hidden = true; }

  function verstuur(formulier) {
    var bedrijf = formulier.dataset.klaviyoCompany;
    var lijst = formulier.dataset.klaviyoList;
    var veld = formulier.querySelector('input[type="email"]');
    var knop = formulier.querySelector('button[type="submit"]');
    var gelukt = formulier.querySelector('[data-klaviyo-success]');
    var mislukt = formulier.querySelector('[data-klaviyo-error]');

    if (!bedrijf || !lijst || !veld || !veld.value) return;

    verberg(gelukt);
    verberg(mislukt);
    if (knop) knop.disabled = true;

    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: formulier.dataset.klaviyoSource || 'Website',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: veld.value,
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: lijst } } }
      }
    };

    fetch(ENDPOINT + '?company_id=' + encodeURIComponent(bedrijf), {
      method: 'POST',
      headers: { 'content-type': 'application/vnd.api+json', revision: REVISION },
      body: JSON.stringify(body)
    })
      .then(function (antwoord) {
        if (antwoord.status === 202) {
          formulier.reset();
          toon(gelukt);
        } else {
          toon(mislukt);
        }
      })
      .catch(function () { toon(mislukt); })
      .then(function () { if (knop) knop.disabled = false; });
  }

  function koppel() {
    document.querySelectorAll('form[data-klaviyo-signup]').forEach(function (formulier) {
      if (formulier.dataset.klaviyoGekoppeld) return;
      formulier.dataset.klaviyoGekoppeld = 'ja';
      formulier.addEventListener('submit', function (gebeurtenis) {
        gebeurtenis.preventDefault();
        verstuur(formulier);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', koppel);
  } else {
    koppel();
  }
  document.addEventListener('shopify:section:load', koppel);
})();
